import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/Card';
import { Badge } from './ui/Badge';
import { ArrowUpRight, ArrowDownRight, MoreHorizontal } from 'lucide-react';
import { Button } from './ui/Button';
import { useNavigate } from 'react-router-dom';
export interface Creator {
  id: string;
  name: string;
  handle: string;
  avatar: string;
  followers: number;
  engagement: number;
  growth: number;
  status: 'active' | 'growing' | 'stable' | 'inactive';
}
interface CreatorTableProps {
  creators: Creator[];
}
export function CreatorTable({
  creators
}: CreatorTableProps) {
  const navigate = useNavigate();
  return <Card className="w-full" data-id="element-145">
      <CardHeader className="flex flex-row items-center justify-between" data-id="element-146">
        <CardTitle data-id="element-147">Portfolio Overview</CardTitle>
        <Button variant="secondary" size="sm" data-id="element-148">
          Export Data
        </Button>
      </CardHeader>
      <CardContent data-id="element-149">
        <div className="overflow-x-auto" data-id="element-150">
          <table className="w-full text-sm text-left" data-id="element-151">
            <thead className="text-xs text-muted-foreground uppercase bg-muted/50" data-id="element-152">
              <tr data-id="element-153">
                <th className="px-4 py-3 rounded-tl-lg" data-id="element-154">Creator</th>
                <th className="px-4 py-3" data-id="element-155">Followers</th>
                <th className="px-4 py-3" data-id="element-156">Engagement</th>
                <th className="px-4 py-3" data-id="element-157">Growth (30d)</th>
                <th className="px-4 py-3" data-id="element-158">Status</th>
                <th className="px-4 py-3 rounded-tr-lg text-right" data-id="element-159">Actions</th>
              </tr>
            </thead>
            <tbody data-id="element-160">
              {creators.map(creator => <tr key={creator.id} className="border-b last:border-0 hover:bg-muted/30 transition-colors cursor-pointer" onClick={() => navigate(`/manager/creators/${creator.id}`)} data-id="element-161">
                  <td className="px-4 py-3 font-medium" data-id="element-162">
                    <div className="flex items-center space-x-3" data-id="element-163">
                      <div className="h-9 w-9 rounded-full bg-gradient-to-tr from-yellow-400 via-red-500 to-purple-600 p-[2px]" data-id="element-164">
                        <div className="h-full w-full rounded-full bg-white p-[2px]" data-id="element-165">
                          <img src={creator.avatar} alt={creator.name} className="h-full w-full rounded-full object-cover" data-id="element-166" />
                        </div>
                      </div>
                      <div data-id="element-167">
                        <div className="font-semibold text-foreground" data-id="element-168">
                          {creator.name}
                        </div>
                        <div className="text-xs text-muted-foreground" data-id="element-169">
                          @{creator.handle}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-4 py-3 font-medium" data-id="element-170">
                    {(creator.followers / 1000).toFixed(1)}k
                  </td>
                  <td className="px-4 py-3" data-id="element-171">{creator.engagement}%</td>
                  <td className="px-4 py-3" data-id="element-172">
                    <div className="flex items-center" data-id="element-173">
                      {creator.growth > 0 ? <ArrowUpRight className="mr-1 h-4 w-4 text-green-500" data-id="element-174" /> : <ArrowDownRight className="mr-1 h-4 w-4 text-red-500" data-id="element-175" />}
                      <span className={creator.growth > 0 ? 'text-green-600' : 'text-red-600'} data-id="element-176">
                        {Math.abs(creator.growth)}%
                      </span>
                    </div>
                  </td>
                  <td className="px-4 py-3" data-id="element-177">
                    <Badge variant={creator.status === 'active' ? 'success' : creator.status === 'growing' ? 'default' : 'secondary'} data-id="element-178">
                      {creator.status}
                    </Badge>
                  </td>
                  <td className="px-4 py-3 text-right" data-id="element-179">
                    <Button variant="ghost" size="sm" className="h-8 w-8 p-0" onClick={e => e.stopPropagation()} data-id="element-180">
                      <MoreHorizontal className="h-4 w-4" data-id="element-181" />
                    </Button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>;
}